import { Col, Container, Row } from 'react-bootstrap'
import { useAdmin } from '../../contexts/AdminContext'
import { useUsers } from '../../contexts/UsersContext'

import './supplier.css'

const Summary = () => {
  const { quotes } = useAdmin()
  const { loggedOnUser } = useUsers()

  const potentialOrders = quotes
  return (
    <>
      <Container>
        <Row className='member-statistical'>
          <Col sm={3}>
            <div className='item blue'>
              <h3>Potential Work Orders</h3>
              <span className='number my_link'>
                {potentialOrders && potentialOrders.length}
              </span>{' '}
              <span className='line'></span>
            </div>
          </Col>
          <Col sm={3}>
            <div className='item green'>
              <h3>Waiting for response</h3>
              <span className='number'>12</span> {/* Get from DB */}
              <span className='line'></span>
            </div>
          </Col>{' '}
          <Col sm={3}>
            <div className='item yellow'>
              <h3>Orders being processed</h3>
              <span className='number'>6</span> {/* Get from DB */}
              <span className='line'></span>
            </div>
          </Col>{' '}
          <Col sm={3}>
            <div className='item purple'>
              <h3>Completed Orders</h3>
              <span className='number'>145</span> {/* Get from DB */}
              <span className='line'></span>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Summary
